import React, { useState } from "react";
import { InformationCircle } from "react-huge-icons/solid";

interface BadgeProps {
  checkboxText: string;
  tooltipText: string;
  id: string;
}

const Badge: React.FC<BadgeProps> = ({
  checkboxText,
  tooltipText,
  id,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <div
      className="flex items-center justify-between py-2.5 px-3 m-1 xl:w-52 max-md:w-full h-14
        bg-secondary rounded-xl border border-tableline shadow-sm shadow-primary/20
        transition-all duration-300 hover:shadow-md relative
        hover:shadow-primary"
    >
      <div className="flex items-center">
        <label htmlFor={id} className="font-medium text-foreground cursor-pointer">
          {checkboxText}
        </label>
      </div>

      {tooltipText && (
        <div
          className="group relative flex items-center"
          onMouseEnter={() => setIsTooltipVisible(true)}
          onMouseLeave={() => setIsTooltipVisible(false)}
        >
          <InformationCircle className="text-primary w-5 h-5 cursor-pointer hover:scale-110 transition-transform duration-200" />

          <div
            className={`absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50
              opacity-0 pointer-events-none
              ${isTooltipVisible ? 'opacity-100 pointer-events-auto' : ''}
              transition-opacity duration-200 ease-in-out`}
          >
            {/* Текст подсказки */}
            <div className="bg-content1 text-foreground px-3 py-2 rounded-lg shadow-lg
              whitespace-normal w-48 break-words"
            >
              {tooltipText}
            </div>

            {/* Маленький "хвостик" указателя */}
            <div className="absolute top-full left-1/2 -translate-x-1/2 -translate-y-0.5 w-0 h-0
              border-l-4 border-r-4 border-t-4 border-transparent border-t-content1"
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Badge;